enum OrganizationTypeEnum {
    ORGANIZATION = 'ORGANIZATION',
    SCHOOL = 'SCHOOL',
    COURSE = 'COURSE',
    STUDENT = 'STUDENT',
  }
  
export default OrganizationTypeEnum
  